export default {
  getAccountFullName(state) {
    return `${state.info?.firstName} ${state.info?.lastName}`;
  },
  getAccountType(state){
	  return `${state.info?.account_type}`;
  },
  getAddressInfo(state){
	  return state.info?.addressInfo;
  },
  getTotal_discount(state){
	  return  state.info?.total_discount;
  },
  getTotal2022Balance(state){
	  return  state.info?.total2022Balance;
  },
  getTotal2023Balance(state){
	  return  state.info?.total2023Balance;
  },
  getPaymentInfo(state){
	  return state.info?.paymentInfo;
  },
  getPriceScaleCode(state){
	  return state.info?.getPriceScaleCode;
  },
  getAccountFirstName(state) {
    return `${state.info?.firstName}`;
  },
  getAccountName(state) {
    return state.info?.accountName;
  },
  getPurlTemplate(state) {
    return state.info?.purl_template;
  },
  getAccountRep(state) {
    return state.info?.rep;
  },
  getUniqAccount(state) {
	  return state.info?.uniqAc;
	},
  getAccounts(state) {
    return state.info.accounts;
  },
  getAccount(state) {
    return state.info;
  },
  getLetterVersion(state) {
    return state.info.accounts?.map((x) => x.letterVersion);
  },
};
